import { css } from 'lit';
export const styles = css `
:host(:focus){outline:0}.-hds-chip-group-wrapper{display:flex}.-hds-chip-group-wrapper ::slotted(hds-chip){margin-right:var(--hds-spacing-2)}
`;
//# sourceMappingURL=hds-chip-group.css.js.map